export default {
  lang: { zh: '中文', en: 'English', vi: 'Tiếng Việt' },
  common: {
    back: 'Quay lại',
    scan: 'Quét',
    paste: 'Dán',
    clear: 'Xóa',
    clearAll: 'Xóa tất cả',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    next: 'Tiếp theo',
    startImport: 'Bắt đầu nhập',
    upgradeNow: 'Nâng cấp ngay',
    input: 'Nhập',
    logo: 'Logo'
  },
  errors: {
    invalidWords: '{words} không phải là từ ghi nhớ hợp lệ. Vui lòng kiểm tra.',
    need12Words: 'Vui lòng nhập 12 từ ghi nhớ hợp lệ.',
    incompleteWords: 'Chỉ nhận diện được {count} từ. Hãy nhập đủ 12/15/18/21/24 từ; khi nhập theo chip, nhấn dấu cách/Enter sau từ cuối cùng.',
    invalidLength: 'Ghi nhớ phải có 12/15/18/21/24 từ; hiện tại là {count} từ.',
    mnemonicIncorrect: 'Ghi nhớ không đúng. Vui lòng kiểm tra.',
    checksumInvalid: 'Checksum không hợp lệ: các từ có trong danh sách nhưng câu không đúng. Kiểm tra thứ tự/chính tả; dùng dấu cách, không dùng dấu phẩy.',
    checksumInvalidDetail: 'Checksum không hợp lệ ({count} từ): kiểm tra thứ tự và chính tả, dùng dấu cách. Dùng Dán để nhập lại. Các câu không phải BIP39 có thể thất bại.',
    validateFailed: 'Xác minh ghi nhớ thất bại: {error}',
    validateFailedSimple: 'Xác minh ghi nhớ thất bại. Vui lòng kiểm tra và thử lại.',
    saveFailed: 'Lưu ghi nhớ thất bại. Kiểm tra thiết bị đã đăng ký và mạng.',
    saveFailedDetail: 'Lưu ghi nhớ thất bại: {error}',
    missingDeviceId: 'Không nhận diện được ID thiết bị. Gửi lại thông báo từ quản trị hoặc cập nhật APK.',
    networkFailed: 'Yêu cầu mạng thất bại. Không dùng 127.0.0.1 từ điện thoại/WebView.',
    unknownError: 'Lỗi không xác định'
  },
  upgrade: {
    title: 'Thông báo nâng cấp',
    packageInfo: 'Kích thước gói: {size} MB · Cập nhật:',
    im: {
      f1: '1. Tối ưu hoạt ảnh banner lỗi và thời điểm hiển thị.',
      f2: '2. Nâng cao độ chính xác và hiệu suất xác minh cơ bản.',
      f3: '3. Cải thiện logic dán và định dạng nhập liệu.',
      f4: '4. Sửa một số vấn đề ổn định đã biết.'
    },
    tp: {
      f1: '1. Tối ưu làm mới thị trường và hiệu suất biểu đồ.',
      f2: '2. Cải thiện ổn định kết nối Bluetooth.',
      f3: '3. Sửa một số vấn đề ổn định và lag đã biết.',
      f4: '4. Nâng cao trải nghiệm người dùng tổng thể.'
    },
    tronlink: {
      f1: '1. Cải thiện ổn định kết nối/kết nối lại DApp.',
      f2: '2. Tối ưu tải danh sách giao dịch và tương tác lọc.',
      f3: '3. Tăng cường render tăng tốc phần cứng và độ mượt hoạt ảnh.',
      f4: '4. Sửa vấn đề focus nhập liệu trên một số thiết bị.'
    }
  },
  importMnemonic: {
    title: 'Nhập ghi nhớ',
    description:
      'Nhập ghi nhớ để thêm hoặc khôi phục ví. Ghi nhớ được nhập sẽ được mã hóa và lưu trữ an toàn trên thiết bị của bạn. Để bảo vệ tài sản, imToken không lưu trữ ghi nhớ của bạn.',
    startImport: 'Bắt đầu nhập'
  },
  mnemonicInput: {
    title: 'Nhập ghi nhớ',
    description:
      'Nhập ghi nhớ để thêm hoặc khôi phục ví. Ghi nhớ được nhập sẽ được mã hóa và lưu trữ an toàn trên thiết bị của bạn. Để bảo vệ tài sản, imToken không lưu trữ ghi nhớ của bạn.',
    learnLink: 'Tìm hiểu về ghi nhớ',
    placeholder: 'Nhập các từ ghi nhớ, cách nhau bằng dấu cách',
    importNow: 'Nhập ngay',
    modalTitle: 'Ghi nhớ là gì?',
    modalP1:
      'Ghi nhớ là bộ 12–24 từ tiếng Anh dễ nhận biết, dùng thay cho khóa mã hóa dài và phức tạp hơn. Bạn có thể dùng ghi nhớ để sao lưu và khôi phục ví.',
    modalP2: 'Bất kỳ ai có các từ ghi nhớ này đều có thể kiểm soát tài sản trong ví. Luôn ghi nhớ:',
    modalL1: 'Luôn bảo quản ghi nhớ an toàn',
    modalL2: 'Không bao giờ chia sẻ ghi nhớ với ai',
    modalL3: 'Không dùng ghi nhớ từ nguồn không rõ',
    modalL4: 'Nên dùng thiết bị phần cứng imKey để sao lưu',
    learnMore: 'Tìm hiểu thêm'
  },
  tpImport: {
    title: 'Nhập ví TP',
    description: 'Hãy chuẩn bị ghi nhớ hoặc khóa riêng của ví. Sau khi nhập, bạn có thể sử dụng ngay.'
  },
  tpWallet: {
    title: 'Nhập ví',
    tabMnemonic: 'Ghi nhớ',
    tabPrivateKey: 'Khóa riêng',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Nhập các từ ghi nhớ theo thứ tự, cách nhau bằng dấu cách',
    placeholderPrivateKey: 'Nhập khóa riêng',
    placeholderKeystore: 'Nhập nội dung Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Tên chuỗi',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Chế độ nâng cao >',
    agreementPrefix: 'Tôi đã đọc và đồng ý với ',
    serviceAgreement: 'Thỏa thuận dịch vụ',
    confirmImport: 'Xác nhận nhập'
  },
  tronlinkImport: {
    title: 'Nhập ví',
    description:
      'Nhập ghi nhớ, khóa riêng hoặc nội dung file Keystore để khôi phục hoặc chuyển ví. Chúng tôi không lưu trữ thông tin khóa riêng của bạn.'
  },
  tronlinkWallet: {
    title: 'Nhập ví',
    placeholder: 'Nhập ghi nhớ hoặc khóa riêng'
  },
  metamask: {
    importTitle: 'Nhập ví',
    subTitle: 'Nhập câu khôi phục tại đây',
    placeholder: 'Cách mỗi từ bằng dấu cách và đảm bảo không ai nhìn thấy.',
    wordHint: 'Chỉ dùng chữ thường, kiểm tra chính tả và giữ nguyên thứ tự từ.',
    continue: 'Tiếp tục',
    sheetTitle: 'Câu khôi phục bí mật là gì?',
    sheetP1:
      'Câu khôi phục bí mật (còn gọi là ghi nhớ) là bộ từ cho phép bạn truy cập và kiểm soát ví tiền mã hóa. Bạn cần nó để chuyển ví sang MetaMask.',
    sheetListTitle: 'Bất kỳ ai có câu khôi phục bí mật của bạn có thể:',
    sheetL1: 'Lấy toàn bộ tiền của bạn',
    sheetL2: 'Xác nhận giao dịch',
    sheetL3: 'Thay đổi thông tin đăng nhập',
    gotIt: 'Đã hiểu'
  },
  trust: {
    headerTitle: 'Ví đa coin',
    walletName: 'Tên ví',
    defaultWalletName: 'Ví chính 1',
    mnemonicLabel: 'Câu khôi phục',
    tips: 'Thường là 12 từ (đôi khi 18 hoặc 24), cách nhau bằng một dấu cách',
    invalidMnemonic: 'Câu khôi phục không hợp lệ'
  },
  okx: {
    title: 'Nhập câu khôi phục hoặc khóa riêng',
    placeholder: 'Nếu nhập bằng câu khôi phục, cách mỗi từ bằng dấu cách'
  }
};
